import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import JournalGroupModel from 'donor-elf-web/models/all-funds/journal-group';
import AllFundsJournalSlimModel from 'donor-elf-web/models/all-funds/journal-slim';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import JournalGroupValidation from 'donor-elf-web/validations/journal-group';
import { type JournalGroupRouteModel } from '../journal-group';
import JournalGroupUserModel from 'donor-elf-web/models/all-funds/journal-group-user';
import CurrentUser from 'donor-elf-web/services/current-user';

export default class JournalGroupEditRoute extends Route {
  @service declare currentUser: CurrentUser;
  @service declare store: Store;

  async model(): Promise<JournalGroupEditRouteModel> {
    let { journalGroup } = this.modelFor(
      'funds.all.journal-groups.journal-group',
    ) as JournalGroupRouteModel;
    let slimJournals: AllFundsJournalSlimModel[] = [];
    let journalGroupUsers: JournalGroupUserModel[] = [];
    let journalGroupName = 'Add Journal Group';
    if (journalGroup.id) {
      slimJournals = (
        await this.store.query('all-funds/journal-slim', {
          filter: { journal_group_id: journalGroup.id },
        })
      ).slice();
      journalGroupUsers = (
        await this.store.query('all-funds/journal-group-user', {
          filter: { journal_group_id: journalGroup.id },
        })
      ).slice();
      journalGroupName = journalGroup.name;
    } else {
      journalGroupUsers = [
        this.store.createRecord('all-funds/journal-group-user', {
          userId: this.currentUser.id,
          user: this.store.createRecord('all-funds/user', {
            firstName: this.currentUser.firstName,
            lastName: this.currentUser.lastName,
          }),
          isOwner: true,
        }),
      ];
    }

    return new JournalGroupEditRouteModel(
      journalGroup,
      slimJournals,
      journalGroupUsers,
      journalGroupName,
    );
  }
}

export class JournalGroupEditRouteModel {
  constructor(
    journalGroup: JournalGroupModel,
    slimJournals: AllFundsJournalSlimModel[],
    journalGroupUsers: JournalGroupUserModel[],
    journalGroupName: string,
  ) {
    this.journalGroup = journalGroup;
    this.slimJournals = slimJournals;
    this.journalGroupUsers = journalGroupUsers;
    this.journalGroupName = journalGroupName;
    this.changeset = new Changeset(
      journalGroup,
      lookupValidator(JournalGroupValidation),
      JournalGroupValidation,
    );
  }

  journalGroup!: JournalGroupModel;
  journalGroupName!: string;
  @tracked slimJournals!: AllFundsJournalSlimModel[];
  @tracked journalGroupUsers!: JournalGroupUserModel[];
  changeset: any;
}
